import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatDate } from "../../Utils/utils";
import CancelIcon from "@mui/icons-material/Cancel";
import { PointObjectInfo } from "../../Interface/user.interface";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogProps,
    DialogTitle,
} from "@mui/material";

interface Prop {
    pointInfo: PointObjectInfo[];
}

const PointsExpDialog = (prop: Prop) => {
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");

    const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const descriptionElementRef = useRef<HTMLElement>(null);
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    return (
        <div className="point-detail-canvas">
            <Typography
                onClick={handleClickOpen("paper")}
                sx={{
                    pt: 2,
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "var(--red)",
                    fontSize: 16,
                }}
            >
                ดูวันหมดอายุ
            </Typography>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: "15px",
                    },
                    p: { md: 3, sm: 3, xs: 0 },
                }}
            >
                <DialogActions
                    sx={{
                        p: { md: 0, sm: 0, xs: 0 },
                    }}
                >
                    <CancelIcon
                        onClick={handleClose}
                        sx={{
                            cursor: "pointer",
                            fontSize: { md: 24, sm: 22, xs: 20 },
                            mt: { md: 2, sm: 1.5, xs: 1 },
                            mr: { md: 2, sm: 1.5, xs: 1 },
                            color: "var(--black)",
                        }}
                    />
                </DialogActions>
                <DialogTitle
                    id="scroll-dialog-title"
                    sx={{
                        pt: 0,
                        pb: 2,
                        fontWeight: "bold",
                        fontSize: { md: 32, sm: 30, xs: 24 },
                        textAlign: "center",
                        textDecorationLine: "underline",
                    }}
                >
                    วันหมดอายุคะแนน
                </DialogTitle>

                <DialogContent
                    dividers={scroll === "paper"}
                    sx={{
                        "& .css-v8vf4i-MuiTypography-root-MuiDialogContentText-root":
                            {
                                color: "var(--black)",
                            },
                        width: { md: 600, sm: 550, xs: 320 },
                        height: { md: 250, sm: 190, xs: 137 },
                    }}
                >
                    <DialogContentText>
                        {prop.pointInfo.map((info: PointObjectInfo) => {
                            return (
                                <Box
                                    id="scroll-dialog-description"
                                    sx={{
                                        fontSize: { md: 28, sm: 26, xs: 20 },
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        px: { md: 3, sm: 2, xs: 1 },
                                        color: "var(--black)",
                                    }}
                                    key={info.expireDate}
                                >
                                    <div>
                                        หมดอายุวันที่{" "}
                                        {formatDate(new Date(info.expireDate))}
                                    </div>
                                    <div>
                                        {info.totalPoints.toFixed(2)} คะแนน
                                    </div>
                                </Box>
                            );
                        })}
                    </DialogContentText>
                </DialogContent>

                <Typography
                    onClick={handleClose}
                    id="scroll-dialog-close"
                    sx={{
                        my: 2.5,
                        fontSize: { md: 24, sm: 22, xs: 20 },
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "var(--red)",
                        textAlign: "center",
                    }}
                >
                    ปิด
                </Typography>
            </Dialog>
        </div>
    );
};

export default PointsExpDialog;
